import React from "react";
import { CategoryContainer } from "../../components/CategoryContainer";
import { AutocompleteRHF } from "../../components/RHFWrappedComponents";
import { situations } from "../../data";

export function Situations() {
  return (
    <CategoryContainer title="Situations">
      <AutocompleteRHF
        name={"additionalInfo.situation"}
        options={situations}
        selectLabel={"Your situations"}
        multiple={true}
      />
    </CategoryContainer>
  );
}
